import React from 'react'

import SocialIcon from './SocialIcon'

interface Props {
  count?: number
}

const Views: React.FC<Props> = ({ count }) => {
  return <SocialIcon className="nf-eye-show" count={count} />
}

export default Views
